const  questionTitles = [
    {  id: 1, text: "Coordinator" }, 
    {  id: 2, text: "Coordinator" }, 
    {  id: 3, text: "Lead Pastor" }, 
    {  id: 4, text: "Lead Pastor" }, 
    {  id: 5, text: "Internship Plan" }, 
    {  id: 6, text: "Internship Plan" }, 
    {  id: 7, text: "Success" }, 
    {  id: 8, text: "Success" }, 
    {  id: 9, text: "Budget" }, 
    {  id: 10, text: "Budget" }, 
    {  id: 11, text: "Housing" }, 
    {  id: 12, text: "Housing" }, 
    {  id: 13, text: "Workspace" }, 
    {  id: 14, text: "Workspace" }, 
    {  id: 15, text: "Time" }, 
    {  id: 16, text: "Time" }, 
    {  id: 17, text: "Job Descriptions" }, 
    {  id: 18, text: "Job Descriptions" }, 
    {  id: 19, text: "Finances" }, 
    {  id: 20, text: "Finances" }, 
    {  id: 21, text: "Experience" }, 
    {  id: 22, text: "Experience" }, 
    {  id: 23, text: "Being a training/sending church" }, 
    {  id: 24, text: "Being a training/sending church" }, 
    {  id: 25, text: "Encouragement" }, 
    {  id: 26, text: "Encouragement" }, 
    {  id: 27, text: "Integration" },
    {  id: 28, text: "Integration" }, 
  
]


export default questionTitles;